import { ReactComponent as BackButtonIcon } from "@icons/back.svg";
import { ContextMenu, ContextMenuListItem } from "shared/UI/ContextMenu/ContextMenu";
import { t } from "i18next";
import { Hideable } from "shared/UI/Hideable/Hideable";
import classNames from "classnames";
import { FunctionComponent, SVGProps } from "react";
import { NarrowContainer } from "shared/UI/LayoutComponents/LayoutComponents";
import { useNavigate } from "react-router-dom";

export type PageHeaderProps = {
  title?: string;
  subtitle?: string;
  hideForMobile?: boolean;
  hideBackForDesktop?: boolean;
  onClickBack?: () => void;
  onClickNext?: () => void;
  narrowView?: boolean;
  backIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  nextIcon?: FunctionComponent<SVGProps<SVGSVGElement>>;
  backTitle?: string;
  nextTitle?: string;
  contextMenuList?: {
    title: string;
    onClick: () => void;
  }[];
};

export const PageHeader = ({
  title,
  subtitle,
  onClickBack,
  onClickNext,
  contextMenuList,
  hideForMobile,
  hideBackForDesktop,
  backIcon,
  nextIcon,
  backTitle,
  nextTitle,
  narrowView = false,
}: PageHeaderProps) => {
  const isMobileApp = !!window.flutter_inappwebview;
  const navigate = useNavigate();

  const BackIcon = backIcon ?? BackButtonIcon;
  const NextIcon = nextIcon ?? BackButtonIcon;

  const headingsBlock = (
    <div className="flex justify-between items-start mb-4">
      <div>
        {title !== undefined && <h1 className="col-start-2 row-start-1 p-0">{title}</h1>}
        {subtitle !== undefined && <h2 className="block lg:mt-[-10px] col-start-2 row-start-2 p-0">{subtitle}</h2>}
      </div>

      <Hideable hidden={!contextMenuList}>
        <div>
          <ContextMenu menuPosition="left">
            {contextMenuList?.map(({ title, onClick }, index) => (
              <ContextMenuListItem text={title} key={index} onClick={onClick} />
            ))}
          </ContextMenu>
        </div>
      </Hideable>
    </div>
  );

  return (
    <div className="flex flex-col gap-4">
      {((isMobileApp && onClickBack && !hideForMobile) || !isMobileApp) && (
        <>
          <div className={classNames({ "block lg:hidden lg:absolute": hideBackForDesktop }, "flex w-full justify-between")}>
            <div className="flex items-center">
              <button
                className="mr-4"
                aria-label={t("navigation.backButton")}
                onClick={() => {
                  onClickBack ? onClickBack() : navigate(-1);
                }}
              >
                <BackIcon className="h-6 w-6" title={t("navigation.backButton")} />
              </button>
              <p className="font-bold">{backTitle ?? "Back"}</p>
            </div>
            {onClickNext && (
              <div className="flex items-center">
                <p className="font-bold">{nextTitle ?? "Next"}</p>
                <button
                  className="ml-4"
                  aria-label={"Next"}
                  onClick={() => {
                    onClickNext && onClickNext();
                  }}
                >
                  <NextIcon className="h-6 w-6 rotate-180" title={"Next"} />
                </button>
              </div>
            )}
          </div>
        </>
      )}
      <Hideable hidden={!!(isMobileApp && hideForMobile)}>{narrowView ? <NarrowContainer>{headingsBlock}</NarrowContainer> : headingsBlock}</Hideable>
    </div>
  );
};
